"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var Modal = function (_a) {
    var children = _a.children, title = _a.title;
    var history = react_router_dom_1.useHistory();
    var backHandler = function (e) {
        if (e.currentTarget.dataset.close === "true")
            history.goBack();
    };
    return (react_1.default.createElement("div", { className: "modal flex flex-column flex-center" },
        react_1.default.createElement("div", { className: "modal__close", onClick: backHandler, "data-close": "true" }, "\u00A0"),
        react_1.default.createElement("div", { className: "modal__view" },
            react_1.default.createElement("div", { className: "modal__top flex flex--row" },
                react_1.default.createElement("div", { className: "modal__title flex flex-row" }, title),
                react_1.default.createElement("button", { className: "back-button flex flex-column flex-center", onClick: backHandler, "aria-label": 'Close Window', "data-close": "true" },
                    react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: "Close" }))),
            react_1.default.createElement("div", { className: "modal__content" }, children))));
};
exports.default = Modal;
